<script setup lang="ts">
const items: {
  title: string
  is_recommended?: boolean
  lists: {
    title: string
    description: string
    icon?: string
  }[]
}[] = [
  {
    title: 'COD Cair Cepat',
    is_recommended: true,
    lists: [
      {
        title: 'Pencairan Dana',
        description: 'Di Hari yang Sama',
        icon: 'material-symbols:bolt'
      },
      {
        title: 'Monitoring Dana',
        description: 'Real Time Dashboard',
        icon: 'material-symbols:monitor-outline'
      },
      {
        title: 'Dukungan Ekspedisi',
        description: 'Puluhan Ekspedisi Populer',
        icon: 'material-symbols:local-shipping-outline'
      },
      {
        title: 'Proses',
        description: 'Otomatis & Transparan',
        icon: 'material-symbols:flip-camera-android'
      },
      {
        title: 'Resiko Tertahan',
        description: 'Minim & Terpantau',
        icon: 'material-symbols:timer-outline'
      }
    ]
  },
  {
    title: 'COD Biasa',
    lists: [
      {
        title: 'Pencairan Dana',
        description: '3-7 Hari'
      },
      {
        title: 'Monitoring Dana',
        description: 'Manual'
      },
      {
        title: 'Dukungan Ekspedisi',
        description: 'Terbatas'
      },
      {
        title: 'Proses',
        description: 'Manual'
      },
      {
        title: 'Resiko Tertahan',
        description: 'Tinggi'
      }
    ]
  }
]
</script>

<template>
  <UiContainer class="flex flex-col gap-11 py-7 lg:py-12">
    <UiSectionTitle
      class="lg:text-center"
      title="Komparasi"
      description="Perbandingan COD Cair Cepat vs COD Biasa"
    />

    <div
      class="flex flex-col md:flex-row justify-center items-stretch gap-6 lg:gap-10"
    >
      <UiCardFeature
        v-for="(item, index) in items"
        :key="index"
        class="flex-1 md:max-w-sm border dark:border-0 border-outline-variant overflow-visible"
        :wrapper-class="{
          'bg-surface-container-low dark:bg-surface-container-low':
            item.is_recommended
        }"
        :ring-class="{
          'bg-gradient-to-b from-primary to-warning': item.is_recommended
        }"
        :disable-background-style="!!item.is_recommended"
      >
        <template v-if="item.is_recommended" #flag>
          <div
            class="bg-gradient-to-b from-primary absolute z-10 top-0 right-5 rounded-full -translate-y-1/2 to-warning p-0.5"
          >
            <div class="bg-secondary-container px-3 py-1 rounded-full">
              <p class="text-primary font-semibold text-sm">
                Lebih Cepat & Praktis
              </p>
            </div>
          </div>
        </template>

        <div class="flex flex-col justify-between gap-6 h-full">
          <p class="font-semibold text-3xl">{{ item.title }}</p>
          <div
            v-for="(list, listIndex) in item.lists"
            :key="`${index}-${listIndex}`"
            class="flex flex-col"
          >
            <p>{{ list.title }}</p>
            <div class="flex items-center gap-2">
              <Icon
                class="flex-none"
                :class="{ 'text-primary': list.icon }"
                :name="list.icon || 'material-symbols:circle'"
                :size="list.icon ? '24px' : '8px'"
              />
              <p class="flex-1 font-semibold">{{ list.description }}</p>
            </div>
          </div>
        </div>
      </UiCardFeature>
    </div>
  </UiContainer>
</template>
